// extracted by mini-css-extract-plugin
module.exports = {"mtkysc5":"mtkysc5","mjiaenw":"mjiaenw","c1az96qp":"c1az96qp"};